import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPathname } from '../utils/navigation_history';

/** Mounted once at the router root; renders nothing. Keeps navigation_history's
 * previous/current pathname in sync with every route change. */
function NavigationHistoryTracker() {
    const location = useLocation();
    useEffect(() => {
        recordPathname(location.pathname);
    }, [location.pathname]);
    return null;
}

export default NavigationHistoryTracker;
